module.exports = __webpack_public_path__ + "static/media/CHARGE.87a20b82.png";